import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'


class PerSurfCompareParagraphList extends React.Component{ 

    state = { modalshow: false};
    state = { modalHeader : '' }
    state = { modalText : '' }

    GetTextCode(ParagraphCode){
        if (window.getSelection)
        {
            //console.log(ParagraphCode);

            var selection = window.getSelection ();
            //console.log(selection);

            var start = selection.anchorOffset;
            var end = selection.focusOffset;
            //console.log(start);
            //console.log(end);
            this.setState({modalHeader: selection.anchorNode.textContent.substring(start,end)});

            var s = selection.anchorNode.textContent.substring(0,start);
            //console.log(s);
            
            var Sequence = ('000'+(s.length - s.replaceAll(" ", "").length + 1));
            Sequence=Sequence.substring(Sequence.length-3,Sequence.length) 
            //console.log(Sequence);

            var TextCode = ParagraphCode+Sequence
            //console.log(TextCode);

            return TextCode;

        }
    }

    showModal = async event => {
        event.preventDefault();
        
        var TextCode=this.GetTextCode(event.target.getAttribute('ParagraphCode'));
        
        //console.log("id:",event.target.id);
        //console.log("id:",this.state.modalshow);
        if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/detail/'+event.target.id+'/null');
            const responseText= await webapi.get('sentence/detail/'+TextCode+'/null');
            this.setState({modalText:responseText.data});
            //alert(responseText.data);
            //this.setState({modalHeader: this.state.modalText.Transcription});
            //console.log("responseText:",responseText);
            if (responseText.data!=='')
                this.setState({modalshow: true});
            //alert(this.state.modalText);
        }
        else
        {
            this.setState({modalshow: false});
            this.setState({modalText: '' });
        }
        
        //console.log("modalText:",this.state.modalText);
        //this.setState({modalshow: true});
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    //const  SurfParagraphList = props => {
    render() {
        return (
            <div>
                <div className="alert" role="alert">
                    {this.props.pageData.length!==0 && this.props.pageData[0].F89905!== undefined?this.props.pageData[0].F89905:89905/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                </div>
                {
                    this.props.ParagraphList.map((Sentence) =>{
                    return  (
                            <div className="container-fluid" id="texts_main_content" key={Sentence.Code} style={{}}>
                                <div className="d-flex container">
                                    <div className="d-inline-block" id="texts_main_content_body">
                                        {
                                            (Sentence.Sentence1)
                                            ?
                                            Sentence.Sentence1.map((Words)=>{
                                                return (
                                                    (Words.Status==="E")
                                                    ? 
                                                    Words.Word1
                                                    :
                                                        (Words.Status==="N")
                                                        ?
                                                        <span style={{color:'orange'}}>{Words.Word1}</span>
                                                        :
                                                        <span style={{color:'red'}}>{Words.Word1}</span>
                                                )
                                            })
                                            :
                                            null
                                        }
                                    </div>
                                    <div className="d-inline-block" id="texts_main_content_body">
                                        {
                                            (Sentence.Sentence2)
                                            ?
                                            Sentence.Sentence2.map((Words1)=>{
                                                return (
                                                    (Words1.Status==="E")
                                                    ? 
                                                    Words1.Word2
                                                    :
                                                        (Words1.Status==="N")
                                                        ?
                                                        <span style={{color:'orange'}}>{Words1.Word2}</span>
                                                        :
                                                        <span style={{color:'red'}}>{Words1.Word2}</span>
                                                )
                                            })
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    (this.state.modalText) 
                    ?
                    (
                        <Modal
                            show={this.state.modalshow}
                            onHide={() => this.setState({modalshow: false})}
                            dialogClassName="modal-90w"
                            aria-labelledby="modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="modal-styling-title">
                                    
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table>
                                    <tbody>
                                    <tr>
                                            <td>
                                                <div className="Caption">Word:</div>
                                            </td>
                                            <td>
                                                <div className="rtlDataPahlavi">{this.state.modalText.Word}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Transcription:</div>
                                            </td>
                                            <td>
                                                <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Transliteration:</div>
                                            </td>
                                            <td>
                                                <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Translation1:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Translation2:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrDataFa">{this.state.modalText.EnTranslation}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Category:</div>
                                            </td>    
                                            <td>   
                                                <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Lemma:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrData">{this.state.modalText.Lemma}</div>
                                            </td>
                                        </tr>
                                        <tr> 
                                            <td>
                                                <div className="Caption">Reference1:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrData">{this.state.modalText.Reference1}</div>
                                            </td>
                                        </tr>
                                        <tr>   
                                            <td>
                                                <div className="Caption">Reference2:</div>
                                            </td>    
                                            <td>     
                                                <div className="ltrData">{this.state.modalText.Reference2}</div>
                                            </td>
                                        </tr>
                                        <tr>   
                                            <td>
                                                <div className="Caption">Note:</div>
                                            </td>    
                                            <td>     
                                                <div className="ltrData">{this.state.modalText.Note}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/*
                                <br />
                                <div className="ltrData">
                                    {
                                        this.state.modalText.Paragraph.map((ParagraphItem,k) =>{
                                            return(
                                                (ParagraphItem.Text===this.state.modalHeader)
                                                ?
                                                    (<span className='HighLight' key={k}>{ParagraphItem.Text}</span>)
                                                :
                                                    (ParagraphItem.Text)
                                            )
                                        })
                                    }
                                </div>
                                 <br />
                                <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                <div className="rtlDataFaNote">{this.state.modalText.ParagraphNote}</div> */}
                            </Modal.Body>
                        </Modal>
                    )
                    :
                    null
                }
            </div>
        )
    }
}

export default PerSurfCompareParagraphList;